import apiClient from "./apiClient";

const BASE_URL = process.env.VUE_APP_BASE_URL as string;

const socialStatusService = {
    async getAll(): Promise<any> {
        try {
            const response = await apiClient.get<any>(
                `${BASE_URL}/api/v1/social-status/all`
            )
            return response.data;
        } catch (error) {
            console.error("Error fetching social status list:", error);
            throw error;
        }
    }
}

export default socialStatusService;